import IService from '../IService';

export default IService.extend({
  _getUrl: function () {
    return app.apiUrl('/api/v1/narrations');
  },

  get: function (uuid) {
    const deferred = new $.Deferred();

    $.ajax({
      url: this._getUrl() + '/' + uuid,
      cache: false,
      type: 'GET',
      timeout: app.TIME.MINUTE,

      error: function () {
        deferred.reject();
      },

      success: function (response) {
        if (
          !_.isEmpty(response) &&
          !_.isEmpty(response.asset) &&
          app.assetType.isAUDIO(response.asset)
        ) {
          deferred.resolve(response);
        } else {
          deferred.reject();
        }
      },
    });

    return deferred.promise();
  },

  post: function (programmerId, fileBlob) {
    const deferred = new $.Deferred();
    const formData = new FormData();

    formData.append('file', fileBlob, fileBlob.name || 'recording.wav');

    $.ajax({
      url: this._getUrl() + '?programmerId=' + programmerId,
      cache: false,
      type: 'POST',
      timeout: 30 * app.TIME.MINUTE,
      processData: false,
      contentType: false,
      data: formData,

      error: function () {
        deferred.reject();
      },

      dataType: 'json',
      success: function (response) {
        if (!_.isEmpty(response) && !_.isEmpty(response.uuid)) {
          deferred.resolve(response);
        } else {
          deferred.reject();
        }
      },
    });

    return deferred.promise();
  },
});
